module.exports = __webpack_public_path__ + "399a5a1c19d2e03dc00aa3736aa5157a.jpg";